"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Acl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Acl = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Acl, _PureComponent);

  var _super = _createSuper(Acl);

  function Acl() {
    (0, _classCallCheck2.default)(this, Acl);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Acl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          read = _this$props.read,
          write = _this$props.write,
          overrideComponent = _this$props.overrideComponent;
      var canSee = read || write;

      if (!canSee) {
        return overrideComponent;
      }

      return _react.default.Children.map(children, function (child) {
        return _react.default.cloneElement(child, {
          disabled: !write
        });
      });
    }
  }]);
  return Acl;
}(_react.PureComponent);

exports.Acl = Acl;
(0, _defineProperty2.default)(Acl, "propTypes", {
  read: _propTypes.default.bool,
  write: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  overrideComponent: _propTypes.default.node
});
(0, _defineProperty2.default)(Acl, "defaultProps", {
  read: false,
  write: false,
  overrideComponent: null
});
//# sourceMappingURL=acl.js.map